<footer class="footer">
  <div class="container">
    <div class="footer-content">
      <div class="footer-section">
        <div class="footer-logo">
          <img src="/images/logo.svg" alt="Strong Towing Services" class="logo-img" />
          <h3>Strong Towing Services</h3>
        </div>
        <p class="footer-description">
          Your trusted partner for reliable towing and roadside assistance services. 
          We're here 24/7 to help you get back on the road safely and quickly.
        </p>
        <div class="social-links">
          <a href="#" class="social-link" aria-label="Facebook">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="#" class="social-link" aria-label="Twitter">
            <i class="fab fa-twitter"></i>
          </a>
          <a href="#" class="social-link" aria-label="Instagram">
            <i class="fab fa-instagram"></i>
          </a>
          <a href="#" class="social-link" aria-label="LinkedIn">
            <i class="fab fa-linkedin-in"></i>
          </a>
        </div>
      </div>

      <div class="footer-section">
        <h4>Services</h4>
        <ul class="footer-links">
          <li><a routerLink="/services">Towing Services</a></li>
          <li><a routerLink="/services">Roadside Assistance</a></li>
          <li><a routerLink="/services">Jump Start</a></li>
          <li><a routerLink="/services">Tire Change</a></li>
          <li><a routerLink="/services">Lockout Service</a></li>
          <li><a routerLink="/services">Fuel Delivery</a></li>
        </ul>
      </div>

      <div class="footer-section">
        <h4>Company</h4>
        <ul class="footer-links">
          <li><a routerLink="/about">About Us</a></li>
          <li><a routerLink="/request-service">Contact</a></li>
          <li><a href="#careers">Careers</a></li>
          <li><a href="#privacy">Privacy Policy</a></li>
          <li><a href="#terms">Terms of Service</a></li>
          <li><a href="#faq">FAQ</a></li>
        </ul>
      </div>

      <div class="footer-section">
        <h4>Contact Info</h4>
        <div class="contact-info">
          <a href="tel:+17032008836" class="contact-item">
            <i class="fas fa-phone"></i>
            <span>+1 (703) 200-8836</span>
          </a>
          <a href="tel:+15712519777" class="contact-item">
            <i class="fas fa-phone"></i>
            <span>+1 (571) 251-9777</span>
          </a>
          <a href="mailto:info@strongtowing.services" class="contact-item">
            <i class="fas fa-envelope"></i>
            <span>info&#64;strongtowing.services</span>
          </a>
          <a href="mailto:billing@strongtowing.services" class="contact-item">
            <i class="fas fa-envelope"></i>
            <span>Billing: billing&#64;strongtowing.services</span>
          </a>
          <a href="mailto:dispatch@strongtowing.services" class="contact-item">
            <i class="fas fa-envelope"></i>
            <span>Dispatch: dispatch&#64;strongtowing.services</span>
          </a>
          <div class="contact-item">
            <i class="fas fa-map-marker-alt"></i>
            <span>Multiple locations across 3 states</span>
          </div>
          <div class="contact-item">
            <i class="fas fa-clock"></i>
            <span>24/7 Emergency Service</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-bottom-content">
        <p>&copy; 2024 Strong Towing Services. All rights reserved.</p>
        <div class="footer-bottom-links">
          <a href="#privacy">Privacy</a>
          <a href="#terms">Terms</a>
          <a href="#cookies">Cookies</a>
        </div>
      </div>
    </div>
  </div>
</footer>